import React, { Fragment } from 'react';
import locales from '../locales/index';

const Translate = ({ language, text }) => (
    <Fragment>
        {locales[language][text]}
    </Fragment>
);


export const t = (language, text) => {
    return locales[language][text]
};

export default Translate;